import React from 'react';
import { Section, SectionHeader } from './ui/Section';
import { Card } from './ui/Card';
import { Reveal } from './ui/Reveal';
import { Button } from './ui/Button';
export function ServicesSection() {
  return <Section id="services" variant="navy" data-id="element-327">
      <SectionHeader title="What I Bring" subtitle="Capabilities & Expertise" data-id="element-328" />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-329">
        <Reveal data-id="element-330">
          <Card className="h-full flex flex-col" data-id="element-331">
            <h3 className="text-2xl font-bold text-white uppercase mb-4 text-center" data-id="element-332">
              Strategic Consulting
            </h3>
            <div className="w-16 h-1 bg-gold-500 mx-auto mb-6" data-id="element-333"></div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-334">
              {['Supply Chain Optimization', 'Crisis Management Frameworks', 'Organizational Leadership Structuring', 'Government Contracting Strategy'].map((item, i) => <li key={i} className="flex items-center text-slate-300" data-id="element-335">
                  <span className="w-1.5 h-1.5 bg-gold-500 mr-3" data-id="element-336"></span>
                  {item}
                </li>)}
            </ul>
            <Button className="w-full" data-id="element-337">Discuss an Opportunity</Button>
          </Card>
        </Reveal>

        <Reveal delay={200} data-id="element-338">
          <Card className="h-full flex flex-col" data-id="element-339">
            <h3 className="text-2xl font-bold text-white uppercase mb-4 text-center" data-id="element-340">
              Keynote Speaking
            </h3>
            <div className="w-16 h-1 bg-gold-500 mx-auto mb-6" data-id="element-341"></div>
            <ul className="space-y-4 mb-8 flex-1" data-id="element-342">
              {['Leading Through Uncertainty', 'The Logistics of Victory', 'Building Resilient Teams', 'Military Precision in Business'].map((item, i) => <li key={i} className="flex items-center text-slate-300" data-id="element-343">
                  <span className="w-1.5 h-1.5 bg-gold-500 mr-3" data-id="element-344"></span>
                  {item}
                </li>)}
            </ul>
            <Button variant="outline" className="w-full" data-id="element-345">
              Invite to Speak
            </Button>
          </Card>
        </Reveal>
      </div>
    </Section>;
}